"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_1 = require("react");
const SvgSpacesDataStatus = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", width: 15, height: 15 }, props),
    React.createElement("circle", { cx: 7.5, cy: 7.5, r: 6.5, style: {
            fill: "#1a699e",
        } }),
    React.createElement("path", { d: "M7 4h1v5H7zM7 10h1v1H7z", style: {
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: "#fff",
        } })));
const Memo = (0, react_1.memo)(SvgSpacesDataStatus);
exports.default = Memo;
//# sourceMappingURL=SpacesDataStatus.js.map